/* Localization Plugin

This is a Vue.js plugin that allows for localization of application through two different methods. It utilizes https://www.i18next.com/ to handle the localization.

The first is a filter, t. For example {{['key', 'key2'] | t}} This will convert the first key found withint he localization files into the appropriate text. So if key is found within default-enUS.js then that text will be used, if not then it will move on to key2 to attempt to find a match.

You may also use the comment <t keys="['key', 'key2']></t>. This will convert the first key found withint he localization files into the appropriate text. So if key is found within default-enUS.js then that text will be used, if not then it will move on to key2 to attempt to find a match.

There are two namespaces, default and contentful. Both the component and the filter attempt to return a matching key from the contentful namespace first before falling back to the default namespace.

NICE_TO_HAVE: Implement custom formatting functions https://www.i18next.com/formatting.html
*/

import i18next from 'i18next';
import defaultKeys from './default-enUS';
import { variableReplace } from '../filters';
import router from '@/router';
import Translatable from './translatable.component';

// Uncomment to generate CSV of application strings
// import downloadKeysCSV from '@/lang/download-keys-csv';
// downloadKeysCSV(defaultKeys, { filename: 'app-string-keys.csv' });

const vi8Next = {};
vi8Next.install = function (Vue, options) {
  options = options ? options : {};
  const i18 = i18next
  .init({
    fallbackLng: 'en',
    debug: false,
    ns: ['default', 'contentful'],
    nsSeparator: '||',
    defaultNS: 'default',
    resources: {
      en : {
        default : defaultKeys,
        contentful: options.contentful_keys
      }
    }
  });

  // the t filter allows for translating text in a template. If you pass in an array if will automatically push contentful content first
  Vue.filter('t', (value) => {
    if (router.currentRoute.query.display_content_keys) {
      if (Array.isArray(value)) {
        return value[0];
      } else {
        return value;
      }
    }

    if (Array.isArray(value)) {
      value = value.map( (item) => {
        return 'contentful||' + item;
      }).concat(value);
    } else {
      if (options.contentful_keys[value]) {
        value = 'contentful||' + value;
      }
    }
    return i18.t(value);
  });

  Vue.component('t', Translatable);
  // 4. add an instance method
  Vue.prototype.$t = (key) => i18.t(key);
  Vue.prototype.$message = (key, variables) => variableReplace.varReplace(i18.t(key), variables);
};

export default vi8Next;